import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react';

import StyledButton, { StyledButtonProps } from './Button.styled';

export type ButtonProps = StyledButtonProps &
  ButtonHTMLAttributes<HTMLButtonElement> & {
    label: string;
    icon?: ReactNode;
  };

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { icon, label, ...rest } = props;
  return (
    <StyledButton ref={ref} type="button" {...rest}>
      {icon}
      <span>{label}</span>
    </StyledButton>
  );
});

export default Button;
